import React from 'react';
import styles from './atoms.module.css';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

export const LB_PAGE_BG = '#dee0e2';

export const LB_ACCENT_BLUE = 'rgb(21, 57, 245)';

export const LB_GRID_COLOR = 'rgb(21, 57, 245)';
export const LB_GRID_COLOR_DEEP = 'rgb(7, 0, 198)';
export const LB_LEADER_GRADIENT =
  'linear-gradient(123deg, #0700c6 61.76%, #1539f5 182.47%)';
export const LB_LEADER_BORDER = 'rgba(21, 57, 245, 0.24)';

export const LB_COUNTDOWN_MAX_W = '388px';

export const LB_CARD_BG = 'rgba(0, 0, 0, 0.02)';
export const LB_CARD_BORDER = 'rgba(173, 173, 173, 0.24)';
export const LB_CARD_BLUR_DESKTOP = '14px';
export const LB_CARD_BLUR_MOBILE = '2px';
export const LB_LEADER_BORDER_WIDTH = '2px';
export const LB_LEADER_BADGE_BG = 'rgba(255, 255, 255, 0.4)';

export const LB_TOGGLE_W = '194px';
export const LB_TOGGLE_H = '36px';
export const LB_TOGGLE_BLUR = '12px';
export const LB_TOGGLE_TRACK_BG = 'rgba(255, 255, 255, 0.16)';
export const LB_TOGGLE_THUMB_BG = 'rgba(255, 255, 255, 0.92)';
export const LB_TOGGLE_THUMB_H = '32px';
export const LB_TOGGLE_FONT_SIZE = '16px';
export const LB_TOGGLE_LABEL_INACTIVE = 'rgba(0, 0, 0, 0.6)';

export const LB_FROST_BLUR = '56px';

export const LB_FROST_BG = 'rgba(255, 255, 255, 0.05)';
export const LB_FROST_BG_ACTIVE = 'rgba(255, 255, 255, 0.24)';
export const LB_FROST_BADGE_BG = 'rgba(255, 255, 255, 0.16)';
export const LB_FROST_INSET_HIGHLIGHT = 'inset 0 1px 1px rgba(255, 255, 255, 0.12)';

/** Mobile sticky header — Figma 2967:3109 blur + bottom fade */
export const LB_STICKY_MOBILE_BLUR = '16px';
export const LB_STICKY_MOBILE_FADE = `linear-gradient(
  180deg,
  rgba(0, 0, 0, 0.03) 0%,
  rgba(0, 0, 0, 0) 84.19%
)`;

export type LbMetaLabelTone = 'live' | 'label' | 'muted' | 'subtle';

export type LbRadialStrokeVariant = 'frosted' | 'card' | 'leader';

export const PageRoot = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.pageRoot, className)} {...props} />
));
PageRoot.displayName = 'PageRoot';

export const Content = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.content, className)} {...props} />
));
Content.displayName = 'Content';

export const SectionWidth = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement> & { as?: any }
>(({ as, className, ...props }, ref) => {
  const Tag: any = as || 'div';
  return (
    <Tag ref={ref} className={cx(styles.sectionWidth, className)} {...props} />
  );
});
SectionWidth.displayName = 'SectionWidth';

export const BackgroundLayer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.backgroundLayer, className)} {...props} />
));
BackgroundLayer.displayName = 'BackgroundLayer';
